<div class="summary">
  <div class="summary-grid">
    <article class="summary-preview">
      <div class="summary-preview__render" #summaryPreview>
        @if (configuration?.composition) {
          <ng-casto-bathroom-render
            [composition]="configuration.composition"
            [selectedElement]="null"
            [isLoading]="configuration.isPreviewLoading">
          </ng-casto-bathroom-render>
        } @else {
          <img [src]="imageSrc" alt="" />
        }
      </div>
      <dl>
        <div>
          <dt>Total TTC</dt>
          <dd>{{ formatPrice(configuration?.totalPrice) }}</dd>
        </div>
        <div>
          <dt>Produits configurés</dt>
          <dd>{{ productsCount }}</dd>
        </div>
      </dl>
    </article>

    <div class="summary-details">
      <article>
        <h3>Gamme & Composition</h3>
        <p>{{ rangeName }}</p>
        <p>{{ compositionName }}</p>
      </article>
      <article>
        <h3>Configuration</h3>
        <p>{{ configuration?.selectedBasinStyle }}</p>
        <p>{{ configuration?.selectedBasinType === 2 ? 'Double vasque' : 'Simple vasque' }}</p>
        @if (configuration?.selectedGlobalWidth) {
          <p>{{ configuration?.selectedGlobalWidth }} cm</p>
        }
      </article>
      @if (error) {
        <p class="summary-error">{{ error }}</p>
      }
    </div>
  </div>
</div>
